// Centralized toast helpers for consistent styling/placement
// Note: Ensure there is a <Toaster /> mounted at the app or page level.
import { toast } from "react-hot-toast";

const baseStyle = {
  fontSize: "14px",
  fontWeight: 400,
  padding: "8px 12px",
  borderRadius: "8px",
  marginTop: "3rem",
  fontFamily: "Urbanist",
  position: 'bottom-center'
};

export function showErrorToast(message, options = {}) {
  const text = String(message || "Something went wrong");
  return toast(text, {
    ...options,
    icon: "",
    position: 'bottom-center',
    style: {
      border: "1px solid #EF4444", // red
      background: "#FFFFFF",
      color: "var(--Base-Black, #000)",
      ...baseStyle,
      ...(options.style || {}),
    },
  });
}

export function showSuccessToast(message, options = {}) {
  const text = String(message || "Done");
  return toast.success(text, {
    ...options,
    icon: "",
    position: 'bottom-center',
    style: {
      // Keep success styling minimal; page-level Toaster may override background/colors
      border: "1px solid #04D9B5",
      background: "var(--Turquoise-Normal, #04d9b5)",
      color: "var(--Base-Black, #000)",
      ...baseStyle,
      ...(options.style || {}),
    },
  });
}
